import { RoutePath } from 'enums/routePath';

const OFFICE365_AUTH_COMPLETE = '/office365/auth/complete';
const OFFICE365_CONSENT_COMPLETE = '/office365/consent/complete';
const ONBOARDING_INVITE = '/onboarding/invite';
const ONBOARDING_CONFIRM = '/onboarding/confirm';
const ONBOARDING_REGISTER = '/onboarding/register';
const ONBOARDING_REGISTER_ACTIVATE = '/onboarding/register/activate';
const ONBOARDING_DOWNLOAD = '/onboarding/download';
const ONBOARDING_EXPIRED = '/onboarding/expired';
const ONBOARDING_EXISTS = '/onboarding/exists';
const ONBOARDING_READY = '/onboarding/ready';
const ONBOARDING_INTEGRATION = '/onboarding/integration';
const ONBOARDING_INTEGRATION_OTHER = '/onboarding/integration/other';
const ONBOARDING_INTEGRATION_OFFICE365_AUTH =
  '/onboarding/integration/office365/auth';
const ONBOARDING_INTEGRATION_OFFICE365_AUTH_ID =
  '/onboarding/integration/office365/auth/:id';
const ONBOARDING_CONNECTWISE = '/onboarding/connectwise';

const paths = {
  [RoutePath.OFFICE365_AUTH_COMPLETE]: OFFICE365_AUTH_COMPLETE,
  [RoutePath.OFFICE365_CONSENT_COMPLETE]: OFFICE365_CONSENT_COMPLETE,
  [RoutePath.ONBOARDING_INVITE]: ONBOARDING_INVITE,
  [RoutePath.ONBOARDING_CONFIRM]: ONBOARDING_CONFIRM,

  [RoutePath.ONBOARDING_REGISTER]: ONBOARDING_REGISTER,
  [RoutePath.ONBOARDING_REGISTER_ACTIVATE]: ONBOARDING_REGISTER_ACTIVATE,
  [RoutePath.ONBOARDING_EXPIRED]: ONBOARDING_EXPIRED,
  [RoutePath.ONBOARDING_DOWNLOAD]: ONBOARDING_DOWNLOAD,
  [RoutePath.ONBOARDING_EXISTS]: ONBOARDING_EXISTS,
  [RoutePath.ONBOARDING_READY]: ONBOARDING_READY,
  [RoutePath.ONBOARDING_INTEGRATION]: ONBOARDING_INTEGRATION,
  [RoutePath.ONBOARDING_INTEGRATION_OTHER]: ONBOARDING_INTEGRATION_OTHER,
  [RoutePath.ONBOARDING_INTEGRATION_OFFICE365_AUTH]:
    ONBOARDING_INTEGRATION_OFFICE365_AUTH,
  [RoutePath.ONBOARDING_INTEGRATION_OFFICE365_AUTH_ID]:
    ONBOARDING_INTEGRATION_OFFICE365_AUTH_ID,
  [RoutePath.ONBOARDING_CONNECTWISE]: ONBOARDING_CONNECTWISE,
};

export const pathArray = Object.values(paths);

export default paths;
